import { render, staticRenderFns } from "./MasterDetailWrapper.vue?vue&type=template&id=572d5790&scoped=true"
import script from "./MasterDetailWrapper.vue?vue&type=script&lang=js"
export * from "./MasterDetailWrapper.vue?vue&type=script&lang=js"
import style0 from "./MasterDetailWrapper.vue?vue&type=style&index=0&id=572d5790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d5790",
  null
  
)

export default component.exports